module.exports = __webpack_public_path__ + "static/media/gatorProtect.1bf3aed5.svg";